import { Box, Flex, Grid } from '@chakra-ui/react';
import { GrantedItem } from '~/types/resources/grantedItem';
import { OrderPrize } from '~/types/resources/orderPrize';
import { OrderPrizeCategory } from '~/types/resources/orderPrizeCategory';
import { TextBorder } from '../common/TextBorder';
import { CollectionPrizeItem } from './CollectionPrizeItem';

type Props = {
  orderPrizes: OrderPrize[];
  grantedPrizes: GrantedItem['prizes'];
  prizeCategories: OrderPrizeCategory[];
  onOpen: () => void;
  setOrderPrize: (newOrderPrize: OrderPrize) => void;
};

export const CollectionPrizeList: React.FC<Props> = (props: Props) => {
  if (props.orderPrizes.length < 1) return null;

  const prizeCategories = props.prizeCategories ?? [];

  const nonCategoryOrderPrize = props.orderPrizes.filter((prize) => {
    return !prizeCategories.some((category) => {
      return prize.prize_category_id == category.id;
    });
  });

  return (
    <>
      {Object.values(prizeCategories).map((category, category_index) => {
        const categoryOrderPrize = props.orderPrizes.filter((prize) => {
          return prize.prize_category_id == category.id;
        });

        if (categoryOrderPrize.length < 1) return null;

        return (
          <Flex key={`category_${category_index}`} flexDir="column" w="full">
            <TextBorder text={category.display_name} />
            <Box h="16px" />
            <Grid
              templateColumns="repeat(3, 1fr)"
              gap={0}
              justifyContent="center"
            >
              {Object.values(categoryOrderPrize).map((prize, index) => {
                return (
                  <CollectionPrizeItem
                    key={`grantedPrize_${index}`}
                    orderPrize={prize}
                    grantedPrizes={props.grantedPrizes}
                    onOpen={props.onOpen}
                    setOrderPrize={props.setOrderPrize}
                  />
                );
              })}
            </Grid>
            <Box h="24px" />
          </Flex>
        );
      })}

      {prizeCategories.length > 0 && nonCategoryOrderPrize.length > 0 && (
        <>
          <TextBorder text="その他" />
          <Box h="16px" />
        </>
      )}
      <Grid templateColumns="repeat(3, 1fr)" gap={0} justifyContent="center">
        {Object.values(nonCategoryOrderPrize).map((prize, index) => {
          return (
            <CollectionPrizeItem
              key={`prize_${index}`}
              orderPrize={prize}
              grantedPrizes={props.grantedPrizes}
              onOpen={props.onOpen}
              setOrderPrize={props.setOrderPrize}
            />
          );
        })}
      </Grid>
      <Box h="24px" />
    </>
  );
};
